// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)               // charge les traductions via HTTP (ou local)
  .use(LanguageDetector)          // détecte langue navigateur
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    debug: true, // enlève en prod
    interpolation: { escapeValue: false },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // structure dossiers
    },
    ns: ['translation', 'home', 'reviews'], // namespaces pour organiser
    defaultNS: 'translation',
  });

export default i18n;